
import { Component, Vue } from 'vue-property-decorator';
import { store } from '@common/store';
import { action } from '@common/store';
import logger from '@plat-components/utils2/_esm5/logger'

@Component({
  name: 'PerSwiper',
  components: {},
})
export default class PerSwiper extends Vue {
  swiperOn = true;
  configList = [
    {
      src: 'https://i0.hdslb.com/bfs/activity-plat/static/c011db88acacfd953923e3e916f928d9/mpTs9IyXEB.png',
      btnName: '虚拟区',
      pclink: 'https://www.bilibili.com',
    },
    {
      src: 'https://i0.hdslb.com/bfs/activity-plat/static/c011db88acacfd953923e3e916f928d9/XCsPVc6Nbz.png',
      btnName: '舞蹈区',
      pclink: 'https://www.bilibili.com',
    },
    {
      src: 'https://i0.hdslb.com/bfs/activity-plat/static/c011db88acacfd953923e3e916f928d9/PzKfwDasx0.png',
      btnName: '生活区',
      pclink: 'https://www.bilibili.com',
    },
    {
      src: 'https://i0.hdslb.com/bfs/activity-plat/static/c011db88acacfd953923e3e916f928d9/K2ld9XGEqj.png',
      btnName: '音乐区',
      pclink: 'https://www.bilibili.com',
    },
    {
      src: 'https://i0.hdslb.com/bfs/activity-plat/static/c011db88acacfd953923e3e916f928d9/nboQnR805e.png',
      btnName: '鬼畜区',
      pclink: 'https://www.bilibili.com',
    },
  ];
  get config() {
    if (!store.swiperData.list) return this.configList;
    console.log('store.swiperList', store.swiperData);
    const swiperList =
      store.swiperData.list?.map((item: any, index: number) => {
        return {
          src: item['children'][1]['object_id'] || this.configList[index].src,
          btnName:
            item['properties']['distract'] || this.configList[index].btnName,
          pclink: item['properties']['pclink'] || '',
        };
      }) || this.configList;
    return swiperList;
  }
  
  activeArr = [ true, false, false, false, false ];
  timer = null as any;
  timestamp = 1000;
  currentIndex = 0;
  // onClickResponse(pclink:string) {
  //   console.log('pclink', pclink);
  //   return false
  //   if(pclink) return true
  //   return false
  // }
  clickCover(btnName: string) {
    logger(`fenqu_click_${btnName}`)
  }
  onHover(curIndex: number) {
    if (this.timer) clearInterval(this.timer);
    this.onMove(curIndex);
  }
  onLeave() {
    this.onAutoPlay();
  }
  onAutoPlay() {
    this.timer = setInterval(
        () => this.onMove((this.currentIndex + 1) % 5),
        this.timestamp
    );
  }

  onMove(activeIndex: number) {
    this.activeArr = this.activeArr.map((item, index) => index === activeIndex);
    this.currentIndex = activeIndex;
  }
  mounted() {
    this.onAutoPlay();
    action.getSwiperData();
  }
  // onLeave(activeIndex: number) {
  //   this.activeArr[activeIndex] = false;
  // }
}
